import React from 'react';
import { useAppSelector } from '../../stores/hooks';
import { ShadeMode } from '../../stores/state';

/**
 * Incomes icon component
 * Displays the custom incomes SVG icon with automatic dark/light mode styling
 */
export const IncomesIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  const mode = useAppSelector((state) => state.vault.mode);
  const arrowColor = mode === ShadeMode.Dark ? '#ffffff' : '#000000';

  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m 1.988224,12.932205 6,-6.0000016 V 22.203392 h -6 z"
        fill="#2e913b"
        fillOpacity="0.298824"
      />
      <path
        d="m 7.988224,6.9322034 6,4.0000016 v 11.271187 h -6 z"
        fill="#2e913b"
        fillOpacity="0.6"
      />
      <path
        d="m 13.988224,10.932205 6,-6.0000016 V 22.203392 h -6 z"
        fill="#2e913b"
        fillOpacity="0.901176"
      />
      <path
        d="m 16,2.6271184 h 6 v 6"
        stroke={arrowColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M 22,2.6271184 13.5,11.12712 8.5,6.1271184 2,12.62712"
        stroke={arrowColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
